import PhotoUploader from './photo-uploader'

export default PhotoUploader
